import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import Can, { checkPermission } from "../common/guards/can";

import './styles.css';

const AdminMenu = ({ userName, hasRewardOutlet }) => (
  <div id="user-panel-wrap">
    <div className="user-panel">
      <DropdownButton bsStyle="primary" title={userName} id="userdropdown">
        <MenuItem href="/admin/my-profile">My Profile</MenuItem>
        {checkPermission('update', 'personal_info') && (
          <MenuItem href="/admin/update-password">Update Password</MenuItem>
        )}
        {checkPermission('update', 'personal_info') && (
          <MenuItem href="/admin/update-security-questions">Update Security Questions</MenuItem>
        )}
        <MenuItem divider/>
        {hasRewardOutlet && (
          <MenuItem href="/points-statement">Points Statement</MenuItem>
        )}
        <MenuItem href="/admin/logout">Logout</MenuItem>
      </DropdownButton>
    </div>
  </div>
);

const mapStateToProps = ({ viewConfig: { profile: user }}) => ({
  hasRewardOutlet: user.attributes['has-reward-outlet'],
  userName: `${user.attributes['first-name']} ${user.attributes['last-name']}`
});

export default connect(mapStateToProps)(AdminMenu);



// WEBPACK FOOTER //
// ./src/components/admin-menu/index.jsx